import type { ISocial } from "../../../../types/models/social.models.types";
import { useGetHttp } from "../../http.hook";

interface IResponse {
  social: ISocial;
}

export function useGetSocialByIdAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/socials/:id",
  });
}
